import type { Capabilities, Session } from "../types";

/** Hide entry points the server would refuse with `capability_disabled` or `media_disabled`. */
export const allows = (session: Session, capability: keyof Capabilities) =>
  session.capabilities?.[capability] === true;
